export type QuestErrorCode = "daily-limit" | "insufficient-han" | "locked" | "not-here";

const MESSAGES: Record<QuestErrorCode, string> = {
  "daily-limit":
    "The free tier includes one new map mission a day. Come back tomorrow or upgrade to Premium for unlimited missions. Retries and replays are still available.",
  "insufficient-han": "Not enough Han for this mission.",
  locked: "Unlock this mission first.",
  "not-here": "Travel to this mission's city first.",
};

export class QuestError extends Error {
  readonly code: QuestErrorCode;

  constructor(code: QuestErrorCode) {
    super(MESSAGES[code]);
    this.code = code;
    this.name = "QuestError";
  }
}
